export default "__VITE_ASSET__DnBEwpx$__"